/* 
https://www.iconfinder.com/icons/1243689/call_phone_icon
Creative Commons (Attribution 3.0 Unported);
https://www.iconfinder.com/Makoto_msk */

export const ourPhones = [
         {
           id: 1,
           title: "Google Pixel - White",
           img: "images/prod-1.png",
           price: 109.99,
           company: "ERICSON",
           info:
             "Lorem ipsum dolor amet offal butcher quinoa sustainable gastropub, echo park actually green juice sriracha paleo. Brooklyn sriracha semiotics, DIY coloring book mixtape craft beer saghjrtorial hella blue bottle. Tote bag wolf authentic try-hard put a bird on it mumblecore. Unicorn lumbersexual master cleanse blog hella VHS, vaporware sartorial church-key cardigan single-origin coffee lo-fi organic asymmetrical. Taxidermy semiotics celiac stumptown scenester normcore, ethical helvetica photo booth gentrify.",
           inCart: false,
           count: 0,
           total: 0,
         },
         {
           id: 2,
           title: "Samsung S8",
           img: "images/prod-2.png",
           price: 100,
           company: "SAMSUNG",
           info:
             "Lorem ipsumhg dolor amet offal butcher quinoa sustainable gastropub, echo park actually green juice srirajjcha paleo. Brooklyn sriracha semiotics, DIY coloring book mixtape craft beer sartorial hella blue bottle. Tote bag wolf authentic try-hard put a bird on it mumblecore. Unicorn lumbersexual master cleanse blog hella VHS, vaporware sartorial church-key cardigan single-origin coffee lo-fi organic asymmetrical. Taxidermy semiotics celiac stumptown scenester normcore, ethical helvetica photo booth gentrify.",
           inCart: false,
           count: 0,
           total: 0,
         },
         {
           id: 3,
           title: "HTC 10 - White",
           img: "images/prod-4.png",
           price: 80,
           company: "htc",
           info:
             "Lorem ipsum dolor yuygygamet offal butcher quinoa sustainable gastropub, echo park actually green juice sriracha paleo. Brooklyn sriracha semiotics, DIY coloring book mixtape craft beer sartorial hella blue bottle. Tote bag wolf authentic try-hard put a bird on it mumblecore. Unicorn lumbersexual master cleanse blog hella VHS, vaporware sartorial church-key cardigan single-origin coffee lo-fi organic asymmetrical. Taxidermy semiotics celiac stumptown scenester normcore, ethical helvetica photo booth gentrify.",
           inCart: false,
           count: 0,
           total: 0,
         },
         {
           id: 4,
           title: "HTC 10 - Black",
           img: "images/prod-3.png",
           price: 120.99,
           company: "htc",
           info:
             "Lorem ipsum dolor amet offal butcher quinoa sustainable gastropub, echo park actually green juice sriracha paleo. Brooklyn sriracha semiotics, DIY coloring book mixtape craft beer sartorial hella blue bottle. Tote bag wolf authentic try-hard put a bird on it mumblecore. Unicorn lumbersexual master cleanse blog hella VHS, vaporware sartoriahbhjbl church-key cardigan single-origin coffee lo-fi organic asymmetrical. Taxidermy semiotics celiac stumptown scenester normcore, ethical helvetica photo booth gentrify.",
           inCart: false,
           count: 0,
           total: 0,
         },
         {
           id: 5,
           title: "HTC Desire 626s",
           img: "images/prod-5.png",
           price: 124,
           company: "htc",
           info:
             "Lorem ipsum dolor amet offal butcher quinoa sustainablpojijoe gastropub, echo park actually green juice sriracha paleo. Brooklyn sriracha semiotics, DIY coloring book mixtape craft beer sartorial hella blue bottle. Tote bag wolf authentic try-hard put a bird on it mumblecore. Unicorn lumbersexual master cleanse blog hella VHS, vaporware sartorial church-key cardigan single-origin coffee lo-fi organic asymmetrical. Taxidermy semiotics celiac stumptown scenester normcore, ethical helvetica photo booth gentrify.",
           inCart: false,
           count: 0,
           total: 0,
         },
         {
           id: 6,
           title: "Xiaomi Mi 4i",
           img: "images/prod-6.png",
           price: 170,
           company: "apple",
           info:
             "Lorem ipsum dolor amet offal butcher quinoa sustainable gijjnbdastropub, echo park actually green juice sriracha paleo. Brooklyn sriracha semiotics, DIY coloring book mixtape craft beer sartorial hella blue bottle. Tote bag wolf authentic try-hard put a bird on it mumblecore. Unicorn lumbersexual master cleanse blog hella VHS, vaporware sartorial church-key cardigan single-origin coffee lo-fi organic asymmetrical. Taxidermy semiotics celiac stumptown scenester normcore, ethical helvetica photo booth gentrify.",
           inCart: false,
           count: 0,
           total: 0,
         },
         {
           id: 7,
           title: "Iphone 10",
           img: "images/prod-7.png",
           price: 130,
           company: "apple",
           info:
             "Lorem ipsum dolor uoh amet offal butcher quinoa sustainable gastropub, echo park actually green juice sriracha paleo. Brooklyn sriracha semiotics, DIY coloring book mixtape craft beer sartorial hella blue bottle. Tote bag wolf authentic try-hard put a bird on it mumblecore. Unicorn lumbersexual master cleanse blog hella VHS, vaporware sartorial church-key cardigan single-origin coffee lo-fi organic asymmetrical. Taxidermy semiotics celiac stumptown scenester normcore, ethical helvetica photo booth gentrify.",
           inCart: false,
           count: 0,
           total: 0,
         },
         {
           id: 8,
           title: "Samsung Galaxy S9",
           img: "images/prod-8.png",
           price: 90,
           company: "apple",
           info:
             "Lorem ipsum dolor amet offal butcher quinoa sustainable gastropub, echo park actually green juice sriracha paleo. Brooklyn sriracha semiotics, DIY coloring book mixtape craft beer sartorial hella blue bottle. Tote bag wolf authentic try-hard put a bird on it mumblecore. Unicorn lumbersexual master cleanse blog hella VHS, vaporware sartorial church-key bjkcardigan single-origin coffee lo-fi organic asymmetrical. Taxidermy semiotics celiac stumptown scenester normcore, ethical helvetica photo booth gentrify.",
           inCart: false,
           count: 0,
           total: 0,
         },
       ];

export const detailPhone = {
  id: 1,
  title: "Google Pixel - Black",
  img: "images/prod-1.png",
  price: 200,
  company: "google",
  info:
    "Lorem ipsum dolor amet offal butcher quinoa sustainable gastropub, echo park actually green juice sriracha paleo. Brooklyn sriracha semiotics, DIY coloring book mixtape craft beer sartorial hella blue bottle. Tote bag wolf authentic try-hard put a bird on it mumblecore. Unicorn lumbersexual master hkgeea cleanse blog hella VHS, vaporware sartorial church-key cardigan single-origin coffee lo-fi organic asymmetrical. Taxidermy semiotics celiac stumptown scenester normcore, ethical helvetica photo booth gentrify.",
  inCart: false,
  count: 0,
  total: 0
};
